__turbopack_context__.v({
  "dateCollapsed": "TrackingEventsList-module__N-ukaG__dateCollapsed",
  "dateExpanded": "TrackingEventsList-module__N-ukaG__dateExpanded",
  "dateLocationCollapsed": "TrackingEventsList-module__N-ukaG__dateLocationCollapsed",
  "dateLocationExpanded": "TrackingEventsList-module__N-ukaG__dateLocationExpanded",
  "orderedList": "TrackingEventsList-module__N-ukaG__orderedList",
  "orderedListItem": "TrackingEventsList-module__N-ukaG__orderedListItem",
});
